// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview_yaml_code_mirror,.preview_yaml_code_mirror .CodeMirror{height:calc(90vh - 150px)}.preview_yaml_code_mirror .CodeMirror-scroll{height:calc(90vh - 150px);overflow-y:hidden;overflow-x:auto}", ""]);
// Exports
module.exports = exports;
